import React from "react";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import { IconMessage2 } from "../../icons/svg";
import { Topic } from "../../tinode/topic";
import DatePicker from "../date-picker.jsx";
import { USER_PROFILE } from '../../tinode/constants'
import { TOPIC_ME } from '../../tinode/config'
import Helpers from "../../lib/helpers";
import { profile } from "../../stores/storages/ProfileStorage";
import LetterTile from "../letter-tile.jsx";
import ContactService from "../../services/contact.js";
import { IconChangeAvatarImage } from "../../icons/svg";
import AvatarCrop from "../avatar-crop.jsx";
import { imageScaled, blobToBase64, makeImageUrl } from "../../lib/blob-helpers.js";
import { AVATAR_SIZE, MAX_AVATAR_BYTES, MAX_EXTERN_ATTACHMENT_SIZE } from "../../config.js";

const messages = defineMessages({
	update_profile_success: {
		id: "update_profile_success",
		defaultMessage: "Update information successful!",
		description: "Update information successful",
	},
	update_profile_error: {
		id: "update_profile_error",
		defaultMessage: "Update information failed!",
		description: "Update information failed",
	}
});

class PersonalInformation extends React.Component {
	constructor(props) {
		super(props);

		this.state = this.getBlankState()

		this.getProfile = this.getProfile.bind(this);
		this.handleOnclickTopicSelected = this.handleOnclickTopicSelected.bind(this);
		this.onTopicNameChange = this.onTopicNameChange.bind(this);
		this.handleOnGenderChange = this.handleOnGenderChange.bind(this);
		this.handleDoneEditProfile = this.handleDoneEditProfile.bind(this);
		this.onBirthdayChange = this.onBirthdayChange.bind(this);
		this.formatDateToCustomString = this.formatDateToCustomString.bind(this);
		this.handleEditProfile = this.handleEditProfile.bind(this);
		this.handleOnChangeAvatarButtonClick = this.handleOnChangeAvatarButtonClick.bind(this);
		this.handleOnFileSelectedChange = this.handleOnFileSelectedChange.bind(this);
		this.handleImageChanged = this.handleImageChanged.bind(this);
		this.handleAvatarCropped = this.handleAvatarCropped.bind(this);
		this.handleAvatarCropCancel = this.handleAvatarCropCancel.bind(this);
		this.uploadAvatar = this.uploadAvatar.bind(this);
		this.uploadWithBaseUrl = this.uploadWithBaseUrl.bind(this);
	}

	componentWillMount() {
		this.getProfile();
	}

	componentDidUpdate(prevProps) {
	}

	getBlankState() {
		const phone = this.props.topicName ? Topic.getThreadId(this.props.topicName) : ''
		return {
			canEdit: false,
			avatar: null,
			name: phone,
			phone: phone,
			birthDay: null,
			gender: USER_PROFILE.GENDER.UNKOWN,
			newAvatarProfile: null,
			newAvatarProfileMime: null,
			avatarProfileName: "",
			uploadUrl: null,
			imageUrl: null,
		}
	}

	getProfile() {
		const { topicName } = this.props
		const topic = this.props.tinode.getTopicByName(topicName)
		let phone = (topicName === TOPIC_ME) ? profile.username : Topic.getThreadId(topicName)

		if (topic && topic.public) {
			let avatar = topic.public.lavatar ? Helpers.getAvatarURL(phone, topic.public.lavatar) : topic?.public?.photo?.ref
			if (topic.isOfficial) {
				avatar = topic?.public?.photo?.ref || null
			}

			const name = topic?.private?.comment || topic?.public?.fn || phone
			if (!topic || !topic.public || !topic.public.state) {
				setTimeout(() => this.props.tinode.getUserProfile(phone))
			}

			// Nghiệp vụ người lạ => ẩn số điện thoại
			if (topic?.stranger) {
				phone = '**********'
			}

			this.setState({
				avatar,
				name,
				phone,
				birthDay: topic.public.birthdayStr ? new Date(topic.public.birthdayStr) : null,
				gender: topic.public.gender,
			})
		}
	}
	handleOnclickTopicSelected() {
		const { topicName } = this.props
		this.props.onTopicSelected(topicName)
		this.props.onClose();
	}

	formatDateToCustomString(date) {
		// Lấy thông tin ngày, tháng, năm từ đối tượng Date
		const year = date.getFullYear();
		const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Thêm '0' phía trước nếu tháng chỉ có một chữ số
		const day = date.getDate().toString().padStart(2, '0'); // Thêm '0' phía trước nếu ngày chỉ có một chữ số	
		// Tạo chuỗi định dạng 'yyyy-MM-dd'
		const formattedString = `${year}-${month}-${day}`;
		return formattedString;
	}

	handleDoneEditProfile = async () => {
		const { topicName } = this.props
		const { formatMessage } = this.props.intl;
		const topic = this.props.tinode.getTopicByName(topicName)
		const phone = (topicName === TOPIC_ME) ? profile.username : Topic.getThreadId(topicName)
		const { avatar, name, birthDay, gender } = this.state
		const updateProfile = await ContactService.setProfile(name, gender, this.formatDateToCustomString(birthDay), birthDay)
		if (updateProfile && (updateProfile.code === 200 || updateProfile.code === '200')) {
			window.logger("Update Personal info Success =", updateProfile)
			if (topic && topic.public) {
				const pub = topic.public
				pub.fn = name
				pub.name = name
				pub.gender = gender
				pub.birthdayStr = this.formatDateToCustomString(birthDay)
				topic.public = pub
				const desc = {
					public: pub,
				}
				topic._processMetaDesc(desc)
				Helpers.showSuccessToasts(formatMessage(messages.update_profile_success))
			} else {
				const publicTopic = {
					fn: name,
					name,
					gender,
					birthdayStr: this.formatDateToCustomString(birthDay)
				}
				topic.public = publicTopic
				const desc = {
					public: publicTopic,
				}
				topic._processMetaDesc(desc)
				Helpers.showSuccessToasts(formatMessage(messages.update_profile_success))
			}
		} else {
			window.logger("Update Personal info Error =", updateProfile)
			Helpers.showSuccessToasts(formatMessage(messages.update_profile_error))
		}
		this.setState({ canEdit: false });
	}

	onTopicNameChange = (e) => {
		this.setState({ name: e.target.value })
	}

	onBirthdayChange = (e) => {
		window.logger("|onBirthdayChange|e=", e)
		this.setState({ birthDay: e })
	}

	handleOnGenderChange = (e) => {
		window.logger("handleOnGenderChange|e=", e.target.value);
		this.setState({ gender: Number(e.target.value) })
	}
	handleEditProfile() {
		const { birthDay } = this.state
		const defaultDate = new Date("1970-01-01");
		if(!birthDay){
			this.setState({ birthDay: defaultDate })
		}
		this.setState({ canEdit: true });
	}

	handleOnChangeAvatarButtonClick = () => {
		this.fileInput.click();
	};

	handleOnFileSelectedChange = async (e) => {
		e.preventDefault();
		const file = e.target.files[0];
		if (file && file.type && file.type.startsWith("image/")) {
			const mimeTypeAvvatar = file.type;
			let nameFileAvatar = "new_avatar_profile";
			const newUrlAvatar = URL.createObjectURL(file);
			if (file.name !== undefined && file.name !== "") {
				nameFileAvatar = file.name;
			}
			//   const uploadAvatarProfile = await ContactService.updateAvatar(file)
			//   if(uploadAvatarProfile && uploadAvatarProfile.lavatar){
			// 	console.log("handleOnFileSelectedChange|resDone=",uploadAvatarProfile)
			//   }else{
			// 	console.log("handleOnFileSelectedChange|res=",uploadAvatarProfile)
			//   }
			this.setState({
				newAvatarProfile: newUrlAvatar,
				newAvatarProfileMime: mimeTypeAvvatar,
				avatarProfileName: nameFileAvatar,
			});
		} else {
			window.logger("handleOnFileSelectedChange wrong file image type");
		}
	};

	handleImageChanged(mime, img) {
		this.setState({ newAvatarProfile: img, newAvatarProfileMime: mime });
	}

	// AvatarCropView calls this method when the user has cropped the image.
	handleAvatarCropped(mime, blob, width, height, fileName) {
		const url = blob ? URL.createObjectURL(blob) : null;
		if (blob) {
			window.logger("handleAvatarCropped|url=", url, "|blob=", blob)
		}
		this.setState({ avatar: url, newAvatarProfile: null, newAvatarProfileMime: null });
		if (blob) {
			this.uploadAvatar(mime, blob, width, height, url);
		}
	}

	async uploadAvatar(mime, blob, width, height, url) {
		const { avatarProfileName } = this.state;
		const readyToUpload = (image) => {
			let { mime, blob } = image;
			this.setState({ imageUrl: URL.createObjectURL(blob) });
			const { topicName } = this.props
			const topic = this.props.tinode.getTopicByName(topicName)
			if (blob.size > MAX_AVATAR_BYTES) {
				// Too large to send inband - uploading out of band and sending as a link.
				//upload avatar
				const uploader = this.uploadWithBaseUrl(
					blob,
					avatarProfileName
				);
			} else {
				// Convert blob to base64-encoded bits.
				blobToBase64(blob).then((b64) =>
					this.setState({
						uploadUrl: makeImageUrl({ data: b64.bits, type: mime }),
					})
				);
			}
		};
		if (width > AVATAR_SIZE || height > AVATAR_SIZE || width != height) {
			// Avatar is not square or too large even after cropping. Shrink it and make square.
			imageScaled(
				blob,
				AVATAR_SIZE,
				AVATAR_SIZE,
				MAX_EXTERN_ATTACHMENT_SIZE,
				true
			)
				.then((scaled) => readyToUpload(scaled))
				.catch((err) => this.props.onError(err.message, "err"));
		} else {
			readyToUpload({ mime: mime, blob: blob, width: width, height: height });
		}
	}

	async uploadWithBaseUrl(blob, fileAvatarName) {
		const { formatMessage } = this.props.intl;
		const { topicName } = this.props
		const topic = this.props.tinode.getTopicByName(topicName)
		const phone = (topicName === TOPIC_ME) ? profile.username : Topic.getThreadId(topicName)
		const file = new File([blob], fileAvatarName);
		const uploadAvatarProfile = await ContactService.updateAvatar(file)
		if (uploadAvatarProfile && uploadAvatarProfile?.lavatar) {
			window.logger("uploadWithBaseUrl|resDone=", uploadAvatarProfile)
			const avatarProfile = Helpers.getAvatarURL(phone, uploadAvatarProfile.lavatar)
			this.setState({ avatar: avatarProfile })
			if (topic && topic.public) {
				const pub = topic.public
				pub.lavatar = uploadAvatarProfile.lavatar
				topic.public = pub
				const desc = {
					public: pub,
				}
				topic._processMetaDesc(desc)
			} else {
				const publicTopic = {
					lavatar: uploadAvatarProfile.lavatar,
				}
				topic.public = publicTopic
				const desc = {
					public: publicTopic,
				}
				topic._processMetaDesc(desc)
			}
		} else {
			window.logger("uploadWithBaseUrl|res=", uploadAvatarProfile)
		}
	}

	handleAvatarCropCancel() {
		this.setState({ newAvatarProfile: null, newAvatarProfileMime: null });
	}

	render() {
		const { topicName } = this.props
		const { canEdit, avatar, name, phone, birthDay, gender } = this.state
		if (canEdit && this.state.newAvatarProfile) {
			return (
				<AvatarCrop
					avatar={this.state.newAvatarProfile}
					mime={this.state.newAvatarProfileMime}
					onSubmit={this.handleAvatarCropped}
					onCancel={this.handleAvatarCropCancel}
					onError={this.props.onError}
				/>
			);
		}
		return (
			<div className="personal-information">
				<div className="header">
					{(topicName === TOPIC_ME || phone === profile.username) && canEdit && <button className="back" onClick={this.props.onClose}>
						<FormattedMessage id="dialog_button_back" defaultMessage={"Back"} />
					</button>}
					<div className="title">
						<FormattedMessage id="dialog_titile_setting_account" defaultMessage={"Account information"} />
					</div>

					{(topicName === TOPIC_ME || phone === profile.username) &&
						<React.Fragment>
							{canEdit ?
								<button className="done" onClick={this.handleDoneEditProfile}>
									<FormattedMessage id="dialog_button_done" defaultMessage={"Done"} />
								</button>
								:
								<button className="done" onClick={this.handleEditProfile}>
									<FormattedMessage id="menu_item_edit" defaultMessage={"Edit"} />
								</button>}
						</React.Fragment>
					}
				</div>
				<div className="avatar-profile-container">
					<div className="avatar-profile avatar-box">
						<LetterTile
							tinode={this.props.tinode}
							avatar={avatar || true}
							topic={topicName}
							title={name}
						/>

						{(topicName === TOPIC_ME || phone === profile.username) && canEdit && (
							<input
								type="file"
								style={{
									display: "none",
								}}
								accept="image/x-png,image/gif,image/jpeg"
								onClick={(e) => {
									e.target.value = null;
								}}
								onChange={this.handleOnFileSelectedChange}
								ref={(fileInput) => (this.fileInput = fileInput)}
							/>
						)}
						{(topicName === TOPIC_ME || phone === profile.username) && canEdit && (
							<div
								className="change-avatar-profile"
								onClick={this.handleOnChangeAvatarButtonClick}
							>
								<IconChangeAvatarImage></IconChangeAvatarImage>
							</div>
						)}
					</div>
				</div>
				{topicName !== TOPIC_ME && profile.username !== Topic.getThreadId(topicName) && <div className="send-message-person" onClick={this.handleOnclickTopicSelected}>
					<IconMessage2 /><span className="send-message-lable">
						<FormattedMessage id="dialog_send_message" defaultMessage={"Send message"} />
					</span>
				</div>}
				<div className="form-input">
					<label htmlFor="name">
						<FormattedMessage id="dialog_label_name" defaultMessage={"Name"} />
					</label>
					<input type="text" name="name" id="name" value={name} readOnly={!canEdit} disabled={!canEdit} onChange={this.onTopicNameChange} maxLength={50} />
				</div>
				<div className="form-input">
					<label htmlFor="phone">
						<FormattedMessage id="dialog_label_mobile" defaultMessage={"Mobile"} />
					</label>
					<input type="text" name="phone" id="phone" value={phone} readOnly={!canEdit} disabled={!canEdit} />
				</div>
				{birthDay && <DatePicker timestamp={birthDay.getTime()} onChange={this.onBirthdayChange} readOnly={!canEdit}/>}
				<div className="form-radio" >
					<label htmlFor="male" className="radio">
						<label htmlFor="male">
							<FormattedMessage id="dialog_label_male" defaultMessage={"Male"} />
						</label>
						<input type="radio" id="male" name="gender" value={1} checked={gender === USER_PROFILE.GENDER.MALE} disabled={!canEdit} onChange={this.handleOnGenderChange} />
						<span className="checkmark"></span>
					</label>
					<label htmlFor="female" className="radio female">
						<label htmlFor="female">
							<FormattedMessage id="dialog_label_female" defaultMessage={"Female"} />
						</label>
						<input type="radio" id="female" name="gender" value={0} checked={gender === USER_PROFILE.GENDER.FEMALE} disabled={!canEdit} onChange={this.handleOnGenderChange} />
						<span className="checkmark"></span>
					</label>
				</div>
			</div>
		)
	}
}

export default injectIntl(PersonalInformation)